import React from "react";
import PropTypes from "prop-types";

function ReserveButton({ reserveLink, showLink, canReserve }) {
  // CVボタン描画
  return (
    <>
      <input name="group_by" type="hidden" value="id" />
      <div className="fair-search-reserve__btn">
        <a
          href={showLink}
          className="action-btn--detail border-color--accent color--accent font-family--middle background-color border-radius--btn"
        >
          フェアの詳細を見る
        </a>
        {canReserve && (
          <a
            href={reserveLink}
            className="action-btn--reserve border-radius--btn background-color--accent border-color--accent font-family--middle"
            data-ct="reserve"
          >
            このフェアを予約
          </a>
        )}
      </div>
    </>
  );
}

/**
 * reserveLink: 予約画面のURL
 * showLink: フェア詳細のURL
 * canReserve: 予約可能 true or false
 */
ReserveButton.propTypes = {
  reserveLink: PropTypes.string.isRequired,
  showLink: PropTypes.string.isRequired,
  canReserve: PropTypes.bool.isRequired,
};

export default ReserveButton;
